var render = function render(){var _vm=this,_c=_vm._self._c;return _c('diV',{staticClass:"content-wrapper",staticStyle:{"height":"350px !important"}},[_c('app-pagination',{attrs:{"total-row":_vm.totalRow,"row-limit":_vm.rowLimit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }